export function updateGenericData(genericData) {
  return async dispatch => {
    dispatch({
      type: 'UPDATE_GENERIC_DATA',
      genericData,
    })
  }
}
